import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { JsonLd, organizationSchema, websiteSchema } from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestNews from './components/LatestNews';
import CTASection from './components/CTASection';

const homeWebPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '黑料在线 - 首页',
  description: '黑料在线 — 最新黑料在线观看与黑料在线播放入口，黑料在线吃瓜视频，网红黑料每日实时更新爆料。',
  url: 'http://baiducc.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '黑料在线',
    url: 'http://baiducc.cn/',
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={homeWebPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestNews />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}